export default "__VITE_ASSET__D8zCWxa7__"